var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-ct card-rounded-shadowed p-4 mb-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"blog-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }